export const DEFAULT_NAME = 'Exodus'
